<template>
  <div id="MainView">
    <b-navbar toggleable="lg" type="dark" class="px-4 py-3">
      <b-nav-form class="navy-fields"></b-nav-form>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav class="mr-4">
            <b-nav-item href="https://www.edai.africa/contact/" target="_blank" link-classes="btn px-4 btn-sm btn-yellow rounded-pill">
              Contact us
            </b-nav-item>
          </b-navbar-nav>
          <!--
          <b-nav-item-dropdown right no-caret>
            <template v-slot:button-content>
              <font-awesome-icon icon="cog"></font-awesome-icon>
            </template>
            <b-dropdown-item href="#">Item 1</b-dropdown-item>
            <b-dropdown-item href="#">Item 2</b-dropdown-item>
            <b-dropdown-item href="#">Item 3</b-dropdown-item>
            <b-dropdown-item href="#">Item 4</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-navbar-nav>
            <b-nav-item href="#">
              <font-awesome-icon icon="bell"></font-awesome-icon>
            </b-nav-item>
          </b-navbar-nav>
          <a href="#" class="profile-icon box-shadow float-right ml-3">
            <span
              class="profile-img"
              :style="'background-image: url(' + require('@/assets/images/avatar-placeholder.jpg') + ')'"
            ></span>
            <span class="initials">JS</span>
          </a>
          -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="px-4 inner-container">
      <h5 class="pl-4 mt-2 title">RADIFY&trade; Statistics</h5>
      <b-row class="inner-row">
        <b-col cols="4" class="inner-col d-flex flex-column">
          <!-- Accordion -->
          <div class="accordion h-100 d-flex flex-column bg-dark-navy" role="tablist">
            <!-- Accordion 1 -->
            <b-card-header header-tag="header" class="p-0 flex-shrink-1" role="tab">
              <b-button block v-b-toggle.accordion-1 class="py-3 px-4">
                Hospitals / Sites
                <b-badge pill class="ml-2 bg-yellow color-black font-weight-400">1</b-badge>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel" class="flex-grow-1 overflow-y scroll-overflow h-100">
              <b-list-group flush>
                <b-list-group-item href="#" active>
                  <h6 class="color-white">Kimberly</h6>
                  <b-row>
                    <b-col>
                      <b-badge pill class="indicator nothing" v-if="lastConnected < 2">
                        <font-awesome-icon icon="heartbeat" class="mr-1"></font-awesome-icon> Recent connection
                      </b-badge>
                      <b-badge pill class="indicator moderate" v-if="lastConnected >= 2 && lastConnected < 24">
                        <font-awesome-icon icon="bell" class="mr-1"></font-awesome-icon> Within a day
                      </b-badge>
                      <b-badge pill class="indicator high" v-if="lastConnected >= 24">
                        <font-awesome-icon icon="exclamation-triangle" class="mr-1"></font-awesome-icon> Over a day ago
                      </b-badge>
                    </b-col>
                    <b-col class="text-right" style="line-height: 1">
                      <small v-if="loadState && stats && stats.info && stats.info.totals"><em>
                        Site: {{ formatDate(stats.info.totals.server_last_updated) }}<br />
                        Cloud: {{ formatDate(stats.info.totals.last_updated) }}
                      </em></small>
                    </b-col>
                  </b-row>
                  <b-row class="m-2">
                    <b-button variant="danger" @click="makePDF">PDF</b-button>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-collapse>
            <!-- END | Accordion 1 -->
          </div>
          <!-- END | Accordion -->
        </b-col>
        <b-col cols="8" class="inner-col d-flex flex-column">
          <result-view v-if="loadState && stats && stats.info && stats.info.totals" :totals="stats.info.totals"></result-view>
          <nothing-view v-else></nothing-view>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { apiRoute, authHeader } from './../../helpers'
import { mapState, mapActions } from 'vuex'

import moment from 'moment'
// import html2pdf from 'html2pdf.js'

import NothingView from './components/Nothing'
import ResultView from './components/View'

export default {
  components: {
    NothingView,
    ResultView
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      stats: state => state.stats
    }),
    loadState () {
      return this.stats.status.loaded
    },
    lastConnected () {
      if (this.loadState && this.stats && this.stats.info && this.stats.info.totals) {
        const _serverDate = new Date(this.stats.info.totals.last_updated)
        const _now = new Date()
        return (_now - _serverDate) / (1000 * 3600)
      } else {
        return 100
      }
    }
  },
  methods: {
    ...mapActions('stats', {
      getTotals: 'getTotals',
      getTotalsPdf: 'getTotalsPdf',
      clearStats: 'clear'
    }),
    displayResult: async function (data) {
      this.current = data

      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }
      const _response = await fetch(apiRoute() + '/api/v1/staff/covid/heatmaps/' + this.current.submission._id, requestOptions)
      const results = await _response.json()
      this.current.heatmaps = results
    },
    formatDate: function (date) {
      return moment(date).fromNow()
    },
    makePDF: function () {
      this.getTotalsPdf('Kimberly')
    }
  },
  mounted () {
    this.getTotals('Kimberly')
  }
}
</script>
